.container {
    position: absolute;
    inset: 0;
}

.map-canvas {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.shadow-inset {
    position: absolute;
    inset: 0;
    z-index: 1;
    box-shadow: inset 0 0 5px 0 rgb(0 0 0 / 10%);
    pointer-events: none;
}

.attribution {
    position: absolute;
    bottom: 0;
    right: 18px;
    z-index: 4;
}

.marker-icon {
    width: 48px;
    height: 48px;
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    pointer-events: none;
}
